import React from "react"
import {Link} from "gatsby-plugin-modal-routing-3"

const BlockModalBtn = ({ children,to, image }) => {

  const styleGround = {
    backgroundImage: 'url(' + image + ')',

  }


  return (
    <Link
    asModal
    to={to === undefined ? window.location.pathname : to}
    >
       <div style={styleGround} className="blockModalBtn-container">
      <div className="overlay">{children}</div>
    </div>
    </Link>
 
  )
}

export default BlockModalBtn
